import React, { ForwardedRef, forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react"
import GUI from "../GUI"
import Overlay, { IOverlay } from "./Overlay"
import { IBackdrop, TBackdropProps } from "./Backdrop"
import type { TAnchorPosition, TAnchorWidth, TAnchorProps} from "./AnchorHelper"
import AnchorHelepr from "./AnchorHelper"

export type { TAnchorPosition, TAnchorWidth, TAnchorProps}

export type TAnchoredBackdropProps = TBackdropProps & {}

function findAnchorTarget(selector:string|undefined){
    return selector ? document.querySelector(selector) || document.querySelector(`[follow-id=${selector}]`) : null
}

var g_anchorId = 0
export default forwardRef( (props:TAnchoredBackdropProps, ref?:ForwardedRef<IBackdrop>) => {
    const {overlayProps} = props
    const anchorProps = overlayProps.anchor!
    const [anchorPosition,setAnchorPosition] = useState<string>(anchorProps.anchorPosition || "below")
    const refSelf = useRef<IOverlay|null>(null)
    const refTimeout = useRef<any>()

    const target = findAnchorTarget(anchorProps.follow)

    const onDown = (e:PointerEvent) => {
        const element = document.elementFromPoint(e.clientX, e.clientY)
        if (refSelf.current?.target?.contains(element)) return true
        else if (!overlayProps.canDismiss || overlayProps.canDismiss?.(e)) props.onDismiss?.(props.overlayId)
        return true
    }

    useImperativeHandle(ref, () => ({onDown}))

    const onDismissed = () => props.onDismissed?.(props.overlayId)
    const anchor = () => {
        const self = refSelf.current?.target
        if (!target) console.log("target not found")
        if (!props.active || !self || !target) return
        setAnchorPosition(AnchorHelepr.anchor(self, target, anchorProps))
        watch()
    }
    const setPosition = () => {
        var {x,y} = anchorProps.position!
        const rSelf = refSelf.current?.target?.getBoundingClientRect()
        if (!rSelf) return
        if (x + rSelf.width>window.innerWidth) x = window.innerWidth - rSelf.width - 16;
        if (y + rSelf.height>window.innerHeight) y = window.innerHeight - rSelf.height - 16
        refSelf.current!.target!.style.setProperty("left", x+"px")
        refSelf.current!.target!.style.setProperty("top", y+"px")
    }
    const watch = () => refTimeout.current = requestAnimationFrame(anchor)
    const unwatch = () => refTimeout.current && cancelAnimationFrame(refTimeout.current)
    useEffect(() => {
        if (refSelf.current && target) {
            if (!GUI.isHTMLElement(target)) return console.warn("Anchor follow not found", anchorProps.follow)
            let anchorName = target.style.getPropertyValue("anchor-name")
            if (!anchorName) {
                anchorName = target.id ? `--${target.id}` : `--overlay_${g_anchorId++}`
                target.style.setProperty("anchor-name", anchorName)
            }
            const positionAnchor = refSelf.current.target?.style.getPropertyValue("position-anchor")
            if (positionAnchor!=anchorName) refSelf.current.target?.style.setProperty("position-anchor", anchorName)
            watch()
        }
        else if (refSelf.current && anchorProps.position) setPosition()
        return () => { unwatch()}
    }, [target])

    const id = props.id ? {id:props.id} : {}
    
    return <Overlay overlay-id={props.overlayId} className={GUI.joinClass(anchorProps.follow ? "anchor" : "", anchorPosition, props.overlayProps.backdropClass)} {...id} {...overlayProps} open={props.active} afterLeaving={onDismissed} ref={refSelf}/>
})